import { objectsRHandler } from '@/utils/objectsRHandler';

import ExpertiseCriteria from '../list/expertise-criteria';
import ExpertiseCriteriaSet from '../list/expertise-criteria-set';
import ExpertiseCriteriaGroup from '../list/expertise-criteria-group';

const API_PATH_CRITERIA = 'expertise-criteria';
const API_PATH_SETS = 'expertise-criterion-sets';
const API_PATH_GROUPS = 'expertise-criterion-groups';

export const ExpertiseCriteriaManager = {
  objects: objectsRHandler(API_PATH_CRITERIA, ExpertiseCriteria),
  sets: objectsRHandler(API_PATH_SETS, ExpertiseCriteriaSet),
  groups: objectsRHandler(API_PATH_GROUPS, ExpertiseCriteriaGroup),
};
